import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledTranslationsOnImage = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);

  .translation-button {
    position: absolute;
    border-radius: 10px;
    cursor: pointer;

    &:hover,
    &.ant-tooltip-open,
    &.editing {
      background: ${Colors.primary}30;
    }
  }

  .translation-tooltip {
    max-width: 80vw;
    .ant-tooltip-content {
      border: 1px solid black;
      border-radius: 8px;
      .ant-tooltip-inner {
        background: #fffc;
      }
    }
  }
`;
